<template>
    <div id="compareHorizontal" style="width:100%;height:100%;">
        <l-map ref="compareHorizontalMap" style="z-index: 0;background-color: black" :options="option"></l-map>
    </div>
</template>

<script>

    import L from 'leaflet';
    import {LMap} from 'vue2-leaflet';
    import '@/lib/side-by-side/leaflet-side-by-side'

    export default {
        name:"CompareHorizontal",
        components: {
            LMap,
        },
        props:["topLayerCite","bottomLayerCite","bounds","compareFullScreen"],
        data() {
            return {
                zoom: 14,
                center: L.latLng(44.0, 125.4),
              option: {zoomControl: false, attributionControl: false, renderer: L.canvas(),zoomSnap:0.01},
            }
        },
        methods: {
          addLayer(){
            this.$refs.compareHorizontalMap.mapObject.setMinZoom(0)
            let topLayer = L.tileLayer('https://tile.charmingglobe.com/map/dataset/' + this.topLayerCite + '/{z}/{x}/{y}?token=Bearer%20a84a40c81f784490a4c5689187054abf',{tms:true}).addTo(this.$refs.compareHorizontalMap.mapObject);
            let bottomLayer = L.tileLayer('https://tile.charmingglobe.com/map/dataset/' + this.bottomLayerCite + '/{z}/{x}/{y}?token=Bearer%20a84a40c81f784490a4c5689187054abf',{tms:true}).addTo(this.$refs.compareHorizontalMap.mapObject)
            //创建卷帘 水平卷帘需要传参数
            L.control.sideBySide(topLayer, bottomLayer,{compareType:"horizontal"}).addTo(this.$refs.compareHorizontalMap.mapObject);
            this.$refs.compareHorizontalMap.mapObject.fitBounds(L.geoJSON(JSON.parse(this.bounds)).getBounds())
            this.$refs.compareHorizontalMap.mapObject.setMaxBounds(L.geoJSON(JSON.parse(this.bounds)).getBounds())
            this.$refs.compareHorizontalMap.mapObject.setMinZoom(this.$refs.compareHorizontalMap.mapObject.getZoom() + 0.1)
          },
          //水平卷帘修改样式，默认是垂直的
          setStyle(){
              document.querySelector(".leaflet-sbs-range").setAttribute("style","height: 100%;top: 0;left:0;width: 100%;");
              document.querySelector(".leaflet-sbs-divider").setAttribute("style","top: 0;left:50%;bottom: 0;margin-left: -2px;width: 4px;height: 100%;");
          },
          zoomIn(){
            this.$refs.compareHorizontalMap.mapObject.zoomIn(0.5)
          },
          zoomOut(){
            this.$refs.compareHorizontalMap.mapObject.zoomOut(0.5)
          },
        },
        mounted() {
            this.addLayer()
            this.setStyle();
        }

    }

</script>

<style scoped lang="scss">

#mainTitle{
    img{
        position: absolute;
        left: 24px;
        top:54px;
        z-index: 10;
    }
    span{
        position: absolute;
        left: 48px;
        top:50px;
        z-index: 10;
        color: white;
    }
    }


    .bottomBar{
        width:100%;
        height: 64px;
        background: rgba(0,0,0,0);
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 9999;
    #openApp{
        color: white;
        font-size: 12px;
        font-weight: 500;
        text-align: center;
        line-height: 32px;
        margin: 16px 24px;
        height: 32px;
        background: #675cb8;
        border-radius: 18px;
    }
}


</style>
